var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{attrs:{"src":_vm.url},on:{"error":_vm.handleError}})
}
var staticRenderFns = []

export { render, staticRenderFns }